import { Injectable, Inject } from '@angular/core';
import { GridDataService } from './core/griddata.service';
import { KalkulationsGruppeService } from '../odata-services';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class KalkulationsGruppeDataService extends GridDataService {
    
  public odataService: KalkulationsGruppeService;
  
  
    constructor(  @Inject(KalkulationsGruppeService)  service: KalkulationsGruppeService, @Inject(NotificationService) notificationService?: NotificationService) { 
      super(service,null,notificationService); 
      this.odataService = service;
    }

}
